// extracted by mini-css-extract-plugin
export default {"inline-icon":"_3UezigcQsc1E94W-rGh7pr"};